<template>
  <div id="page_product">
    <div class="banner">
      <img src="../assets/img/产品页-banner.jpg" alt="" class="bg">
      <div class="textbox">
        <h2 class="wow fadeInDown">Brotex Offering An Expansive Library Of Sound Absorption Products And Accessory Options</h2>
      </div>
      <div class="crumb">
        <router-link to="./Index">HOME</router-link>
        <router-link to="./Product">PRODUCT</router-link>
      </div>
    </div>
    <div class="nav">
      <div class="item" :class="index==catIndex?'active':''" v-for="(item,index) in catList" :key="index" @click="changeList(index,item.id,1)">
        {{item.name}}
        <span>{{item.name2}}</span>
      </div>
<!--      <div class="item" :class="item.onflag==true?'active':''" v-for="(item,index) in catList" :key="index" @click="changeList(index,item.id)">-->
<!--        {{item.name}}-->
<!--        <span>{{item.name2}}</span>-->
<!--      </div>-->
    </div>
    <div id="part1">
      <div class="itembox">
        <router-link class="item" :to="{path:'./ProductInfo',query:{id:item.id}}" v-for="(item,index) in proList" :key="index" target="_blank">
          <div class="imgbox">
            <i class="triangle-topleft"></i>
            <img :src="`${$https}${item.img}`" alt="">
            <i class="triangle-topright"></i>
            <div class="cover"></div>
          </div>
          <p>{{item.name}}</p>
          <div class="mainBtn2"><span>LEARN MORE</span><i>></i></div>
        </router-link>
      </div>
      <div class="empty" v-show="proList.length==0"><i class="iconfont icon--listEmpty"></i><span>No result!</span></div>
      <el-pagination class="pagniation"
         layout="prev, pager, next"
         @current-change="handleCurrentChange"
         :page-size="pageSize"
         :total="total">
      </el-pagination>
    </div>
    <div id="part2" class="full">
      <div class="mainTitle1 textbox white">
        <h3>Technology</h3>
        <p>According to the micro-perforated plate theory (MPP) proposed by Academician Ma Dayou in 1966, Brotex developed a series of ultrafine microporous sound-absorbing plates with high sound absorption coefficient after a long period of continuous testing by the technical team. Compared with traditional sound-absorbing materials, the sound absorption coefficient of this series of products is excellent in the whole frequency band, especially in the low-frequency part. At the same time, it can also achieve a good sound absorption effect without adding porous sound absorption material behind the board, which reduces the installation conditions.</p>
      </div>

    </div>

    <!-- <div id="part3">
      <div class="left">
        <div class="mainTitle1 textbox">
          <h3>Our Certification</h3>
          <p>Certificates can not only prove our strength, but also bring customers security and trust.
            Brotex can offer an expansive library of sound Absorption products and accessory options. These utilize our sustainably sourced, 100% recyclable, lightweight and durable high-performance material. Brotex comes a wide range of colors and finishes, including wood textures, with available customization, to help you achieve the look you need while you build noise reduction into your spaces.</p>
        </div>
      </div>
      <div class="right">
        <swiper class="swiper3" ref="swiper3" :options="swp3opt" :auto-update='true'>
          <swiper-slide>
            <img src="../assets/img/首页-证书1.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页-证书2.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页-证书3.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页证书4.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate1.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate2.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate3.jpg" alt="">
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp3" slot="button-prev"></div>
        <div class="swiper-button-next sbn3" slot="button-next"></div>
      </div>
    </div> -->
    <comment></comment>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import comment from "../components/comment";
import * as $request from "../api/index";
export default {
  name: "Product",
  metaInfo:{
    title:'Guangdong Brotex Acoustic Technology Co.,Ltd | Product',
  },
  components:{
    comment,
  },
  data(){
    return{
      catIndex:0,
      catId:0,
      catList:[
        {
          id:0,
          name:'Perforated Acoustic Panel',
          name2:'Acoustic Panel',
          onflag:false,
        },
        {
          id:0,
          name:'Grooved Acoustic Panel',
          name2:'Acoustic Panel',
          onflag:false,
        },
        {
          id:0,
          name:'Wood Wool Acoustic Panel',
          name2:'Acoustic Panel',
          onflag:false,
        },
        {
          id:0,
          name:'Fabric Acoustic Panel',
          name2:'Acoustic Panel',
          onflag:false,
        },
        {
          id:0,
          name:'Metal Acoustic Panel',
          name2:'Acoustic Panel',
          onflag:false,
        },
        {
          id:0,
          name:'Art Acoustic Panel',
          name2:'Acoustic Panel',
          onflag:false,
        },
        {
          id:0,
          name:'Melamine Acoustic Foam',
          name2:'Acoustic Panel',
          onflag:false,
        },
      ],
      swp3opt:{
        slidesPerView: 3,
        slidesPerColumn: 1,
        // spaceBetween: 25,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn3',
          prevEl: '.sbp3'
        },
      },
      proList:[],
      pageSize:9,//每页几个
      pageIndex:1,//第几页
      total:0,//总数
    }
  },
  methods:{
    // changeList(index,id){
    //   this.catList[index].onflag=!this.catList[index].onflag
    //   if(this.catList[index].onflag==true){//请求该列表
    //     console.log(id)
    //   }
    // },
    async changeList(index,cid,pageIndex){
      // console.log(index,cid,`page:${pageIndex}`)
      this.catId=cid
      this.pageIndex=pageIndex
      await $request.getShops(this.catId,this.pageIndex,this.pageSize).then(res=>{
        this.proList=res.datas
        this.total=res.totalCount
        // console.log(this.proList)
      })
      this.catIndex=index
    },
    handleCurrentChange(val) {
      this.pageIndex=val
      this.changeList(this.catIndex,this.catId,this.pageIndex)
    }
  },
  created() {
    this.$emit('getnav',1)
    $request.getCats().then(res=>{
      res.forEach(val=>{
        if(val.name=='en'){
          this.catList=val.sonList
          // console.log(this.catList)
          if(this.$route.query.cin){
            this.catIndex=this.$route.query.cin
            // console.log(this.catList[this.catIndex])
          }
          this.changeList(this.catIndex,this.catList[this.catIndex].id,1)
        }
      })
    })
  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<style lang="less" scoped>
#page_product{
  .banner{height: 536px;position: relative;z-index: 1;padding: 230px 0 0 0px;text-align: center;overflow: hidden;
    .bg{position: absolute;bottom: 0;right: 0;z-index: -1;}
    .textbox{
      h2{color: white;width: 55%;margin: 0 auto;}
    }
    .crumb{font: 20px Poppins-SemiBold;margin-top: 60px;
      a{color: white;
        &:not(:last-child):after{content: '>';margin: 0 20px;}
        &:last-child{border-bottom: 1px solid white;}
      }
    }
  }
  .nav{display: flex;
    .item{width: calc(100% / 7);border-right: 1px solid #DCDCDF;background: #F5F5F5;padding: 40px 20px;text-align: center;display: inline-flex;flex-direction: column;font: 22px Poppins-Medium;cursor: pointer;position: relative;
      color: @main-c4;justify-content: center;
      span{font: 18px Poppins-Regular;}
      &:hover,&.active{background: @main-c1;
        &:after{transition: .3s;content: " ";bottom: -21px;left: 50%;transform: translate(-50%,-50%);position: absolute;width: 0;height: 0;color: #fff;text-align: center;border-top: 14px solid @main-c1;
          border-left: 7px solid transparent;border-right: 7px solid transparent;z-index: 1;}
      }
      &:last-child{border: none;}
    }
  }
  #part1{margin-top: 80px;
    .itembox{display: flex;justify-content: flex-start;flex-wrap: wrap;
      .item{display: block;width: calc((100% - 64px) / 3);margin-bottom: 45px;
        &:not(:nth-child(3n)){margin-right: 32px;}
        .imgbox{position: relative;overflow: hidden;
          .cover{position: absolute;opacity: 0;background: black;width: 100%;height: 100%;left: 0;top: 0;transition: .6s;}
          img{width: 100%;height: 245px;object-fit: contain;}
          .triangle-topleft{width: 0px;height: 0px;border-top: 40px solid @main-c1;border-right: 40px solid transparent;position: absolute;top: 0;left: -40px;transition: .6s;z-index: 2;}
          .triangle-topright{width: 0px;height: 0px;border-bottom: 40px solid @main-c1;border-left: 40px solid transparent;position: absolute;bottom: 0;right: -40px;transition: .6s;z-index: 2;}
        }
        p{font: 20px Poppins-Medium;padding: 25px 0;color: @main-c4;}
        &:hover{
          .cover{opacity: .2;}
          .imgbox{
            .triangle-topleft{left: 0;}
            .triangle-topright{right: 0;}
          }
          .mainBtn2{width: auto;padding: 2px 15px 0;background: @main-c1;border-color: @main-c1;
            span{transform: translateX(0%);position: relative;margin-right: 10px;opacity: 1;}
          }
        }
      }
    }
    .empty{display: flex;align-items: center;justify-content: center;flex-direction: column;
      .iconfont{font-size: 200px;opacity: .2;}
      span{font: 20px Ubuntu-R;opacity: .3;margin: 20px 0;}
    }
  }
  #part2{display: flex;background: url("../assets/img/product_part2bg.jpg") no-repeat 50% 50%/cover;
    .mainTitle1{margin: 0 ;
      h3{margin-bottom: 40px;}
      p{width: 50%;}
    }
  }
  #part3{display: flex;justify-content: space-between;align-items: center;position: relative;z-index: 1;
    .wave3d{position: absolute;right: 0%;top: 0;width: 50%;height: 100%;z-index: -1;}
    .left{width: 40%;
      .mainTitle1{margin: 0;
        h3:before{left: -8%;}
        p{width: 100%;}
      }
    }
/*    .right{
      img{margin-right: 20px;width: 216px;}
    }*/
    .right{width: 60%;padding-left: 85px;position: relative;
      img{width: 216px;}
      .swiper-container{
        width: 100%;
      }
      .swiper-slide{width: 250px!important;}
      .sbp3 {
        left: 0 !important;
      }
      .sbn3{
        right: -10%!important;
      }
    }
  }
}
</style>